import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/form-selection-control/dist/styles.css';
import '@vfde-brix/notification/dist/styles.css';
import '@vfde-brix/ribbon-badge/dist/styles.css';
import '@vfde-brix/suggest-field/dist/styles.css';
import '@vfde-brix/system-icon/dist/styles.css';
import '@vfde-brix/promo-tile/dist/styles.css';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createPromoTileComponent } from '@vfde-brix/promo-tile';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-promo-tile', createPromoTileComponent, NO_PATTERN_BUSINESS_LOGIC);
